import { useLingui } from '@lingui/react/macro';
import { DatePicker } from '@repo/videa-components';
import { useAtom, useSetAtom } from 'jotai';

import { useGetDateFNSLocale } from '@/locales/helpers';

import {
  operatoryFilterAtom,
  selectDateAtom,
  selectedProvidersAtom,
} from '../../../../modules/patientList/atoms';

export const ClaimsTopbarContent = () => {
  const { t } = useLingui();
  const dateLocale = useGetDateFNSLocale();

  const [date, setDate] = useAtom(selectDateAtom);
  const setSelectedOperatories = useSetAtom(operatoryFilterAtom);
  const setSelectedProviders = useSetAtom(selectedProvidersAtom);

  const handleSelectDate = (newDate: Date) => {
    setDate(newDate);
    setSelectedOperatories([]);
    setSelectedProviders([]);
  };

  return (
    <>
      {/* Date Picker with Navigation */}
      <DatePicker
        date={date || undefined}
        setDate={handleSelectDate}
        placeholderText={t`Pick a date`}
        locale={dateLocale}
        showPreviousNextButtons
        showTodayButton
        todayButtonText={t`Back to Today`}
      />
    </>
  );
};
